export default __webpack_public_path__ + "static/logo13-7a0ff089b9cbb6575b61bc5b3a13d58e.png";